import React, { useState } from 'react';

const HomeBMI = () => {
  // State variables for weight, height, BMI value, and weight status
  const [weight, setWeight] = useState('');
  const [height, setHeight] = useState('');
  const [bmiValue, setBmiValue] = useState('');
  const [weightStatus, setWeightStatus] = useState('');

  // Function to calculate BMI and determine weight status
  const calculateBMI = () => {
    // Validate inputs
    if (!weight || !height) {
      alert('Please enter both weight and height.');
      return;
    }

    const weightNum = parseFloat(weight);
    const heightNum = parseFloat(height) / 100; // Convert height to meters

    // Check for valid numbers
    if (isNaN(weightNum) || isNaN(heightNum) || heightNum === 0) {
      alert('Please enter valid numbers for weight and height.');
      return;
    }

    // Calculate BMI
    const bmi = weightNum / (heightNum * heightNum);
    setBmiValue(bmi.toFixed(2));

    // Determine weight status
    let status = '';
    if (bmi < 18.5) {
      status = 'Under-Weight';
    } else if (bmi >= 18.50 && bmi < 24.9) {
      status = 'Normal';
    } else if (bmi >= 25 && bmi < 29.9) {
      status = 'Over-Weight';
    } else {
      status = 'Obese';
    }

    setWeightStatus(status);
  };

  // Function to determine the color based on weight status
  const getColor = () => {
    switch (weightStatus) {
      case 'Under-Weight':
        return 'orange';
      case 'Normal':
        return '#11d006';
      case 'Over-Weight':
        return 'red';
      case 'Obese':
        return 'red'; // You can customize this color if needed
      default:
        return 'black'; // default color for unassigned or empty status
    }
  };

  const color = getColor();

  return (
    <section className="bmi-section">
      <div className="bmi-outer-div">
        <h2 className="bmi-heading">
          Let's Calculate Your <span>BMI</span>
        </h2>
        <p className="bmi-paragraph">
          Easily determine your body mass index with our accurate calculation tool.
        </p>
        <div className="bmi-form-container">
          <form className="bmi-form">
            <div className="bmi-input-container">
              <input
                type="text"
                className="bmi-input"
                placeholder="Weight / Kg"
                value={weight}
                onChange={(e) => setWeight(e.target.value)}
              />
              <input
                type="text"
                className="bmi-input"
                placeholder="Height / Cm"
                value={height}
                onChange={(e) => setHeight(e.target.value)}
              />
            </div>
            <p className="bmi-info-text">
              <span className="bmi-highlight">Your BMI is: </span>
              <span className="bmiValue" style={{ color: color }}>
                {bmiValue}
              </span>
            </p>
            <p className="bmi-info-text">
              <span className="bmi-highlight">Your Weight Status is: </span>
              <span className="weightStatusValue" style={{ color: color }}>
                {weightStatus}
              </span>
            </p>
            <button type="button" className="bmi-button" onClick={calculateBMI}>
              CALCULATE
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default HomeBMI;
